import { Box, Modal, Typography, IconButton } from "@mui/material";
import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";

const CustomModal = ({
  open,
  onClose,
  title,
  children,
  titleColor = "success",
  minWidth = "70vw",
  maxWidth = "70vh",
  minHeight = "30vh",
  maxHeight = "80vh",
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          color: "text.primary",
          boxShadow: 24,
          p: 3,
          borderRadius: 3,
          overflowY: "auto",
          minHeight,
          maxWidth,
          minWidth,
          maxHeight,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "text.secondary",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h4" fontWeight="bold" color={titleColor} mb={2}>
          {title}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>{children}</Box>
      </Box>
    </Modal>
  );
};

CustomModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  titleColor: PropTypes.string,
  minWidth: PropTypes.string,
  minHeight: PropTypes.string,
  maxHeight: PropTypes.string,
  maxWidth: PropTypes.string,
};

export default CustomModal;
